export enum TransmissionMethod {
  EMAIL = 'EMAIL',
  LETTER = 'LETTER',
  IN_PERSON = 'IN_PERSON',
}

export const getTransmissionMethodLabel = (
  value: TransmissionMethod
): string => {
  switch (value) {
    case TransmissionMethod.EMAIL:
      return $localize`Email`;
    case TransmissionMethod.LETTER:
      return $localize`Courrier`;
    case TransmissionMethod.IN_PERSON:
      return $localize`Physique`;
  }
};
